import { render } from "./collectInvoice.vue?vue&type=template&id=2eff30c6"
import script from "./collectInvoice.vue?vue&type=script&lang=js"
export * from "./collectInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__